import type { GetAllPostsByAppVariantAndSelectedGeoAreasRequest } from '@DigitaleDoerfer/digitale-doerfer-api';

import {
  RegionTab,
  type RegionFilterChange
} from '@/features/geo-area/components/region/regionTypes';
import { useGetPostsParams } from '@/features/posts/hooks/useGetPostsParams';
import { PostFeedType } from '@/features/posts/types/postFeed';

const POST_FEED_TYPE: Record<RegionTab, PostFeedType> = {
  [RegionTab.MINISTRIES]: PostFeedType.ALL,
  [RegionTab.REGIONAL_RADIO]: PostFeedType.NEWS_ITEM,
  [RegionTab.EMERGENCY]: PostFeedType.CIVIL_PROTECTION,
  [RegionTab.EVENTS]: PostFeedType.HAPPENING
};

export type RegionParams = GetAllPostsByAppVariantAndSelectedGeoAreasRequest & {
  radiusKm?: number;
};

export const useRegionParams = (
  activeTab: RegionTab,
  filter: RegionFilterChange | undefined
): RegionParams => {
  // Region feeds deliberately include posts targeted at ancestor areas
  // (hierarchy distribution) — opt out of the "Mein Ort" leaf-only scope.
  const baseParams = useGetPostsParams(POST_FEED_TYPE[activeTab], {
    onlyExplicitlySelectedGeoAreas: false
  });

  if (!filter || filter.tab !== activeTab) {
    return baseParams;
  }

  return { ...baseParams, radiusKm: filter.radiusKm };
};
